import { render, staticRenderFns } from "./ItemProfile.vue?vue&type=template&id=188f8392"
import script from "./ItemProfile.vue?vue&type=script&lang=js"
export * from "./ItemProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports